// extracted by mini-css-extract-plugin
export default {"contents":"Search_contents__vIeaG","input":"Search_input__tYiYe","icon":"Search_icon__PsNzK","results":"Search_results__+5jwD"};